import { jwtDecode } from 'jwt-decode'
export class jwtDecodingService {
  public static getDecodedAccessToken(token: string | undefined): any {
    try {
      if (token == undefined)
        return null;
      return jwtDecode(token);
    } catch (Error) {
      return null;
    }
  }
}